module.exports = __webpack_public_path__ + "static/media/no-buildings.9718be88.svg";